import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Dialog from '../../../../UiComponents/Dialog';
// import OrgChart from './../../../../orgChart';
import OrgChart from './../../../../mailThread/compose/actorsHandler/orgChart'
import ClientOrgChart from './../../../../mailThread/compose/actorsHandler/clientOrgChart'
import getLabel from './../../../../../utils/labels'
import orgChart from '../../../../../globals/images/orgChart.png';
import zoom from '../../../../../globals/images/zoom.svg';
import close from '../../../../../globals/images/close.svg';
import styles from './character.module.scss';
import analytics from './../../../../../utils/segmentUtils'

class Character extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showMask: false,
            showZoomedImage: false
        }
    }

    componentDidMount() {
        analytics.page('Character')
    }

    addMask = () => {
        this.setState({
            showMask: true
        });
    }

    removeMask = () => {
        this.setState({
            showMask: false
        });
    }

    showZoomedImage = () => {
        this.setState({
            showZoomedImage: true
        });
    }

    closeZoomedImage = () => {
        this.setState({
            showZoomedImage: false
        });
    }

    checkIfOptionPresentInArray = (array, element) => {
        return array.includes(element);
    }

    getOrgChartImage = () => {
        const { showZoomedImage, showMask } = this.state;
        return (
            <div style={showZoomedImage ? { width: '75%', maxWidth: 'none', height: '90%' } : {}} className={styles['org-chart']} >
                {/* <img src={orgChart} className={styles['org-chart-img']} /> */}
                <div style={{ backgroundColor: 'white', overflow: 'auto', height: '100%' }}>
                    <div
                        className={styles['orgchart-container']}
                        style={showZoomedImage ? { zoom: '1' } : {}}
                    >
                        <OrgChart
                            selectedActors={[]}
                            orgChart={this.props.orgChart}
                            selfActor={this.props.selfActor}
                            checkIfOptionPresentInArray={this.checkIfOptionPresentInArray}
                        />
                        <ClientOrgChart
                            selectedActors={[]}
                            actors={this.props.actors}
                            checkIfOptionPresentInArray={this.checkIfOptionPresentInArray}
                            isIntroImage={true}
                            ref={(el) => {
                                this.orgChartDiv = el;
                            }}
                        />
                    </div>
                    {(showMask && !showZoomedImage) ? <div className={styles['zoom-cursor']}> </div> : null}
                </div>
                {
                    !showZoomedImage ?
                        <div className={styles['zoom-button']} >
                            <img src={zoom} className={styles['zoom-img']} />
                            {getLabel('label_zoom_button')}
                        </div>
                        :
                        <img src={close} className={styles['close-img']} onClick={this.closeZoomedImage} />
                }
            </div >
        );
    }

    render() {
        const { showMask, showZoomedImage } = this.state;
        const { introductionData } = this.props;

        return (
            <React.Fragment>
                <div className={styles['character-info-container']}>
                    <div className={styles['info-left']} dangerouslySetInnerHTML={{ __html: introductionData.step2.content }} />

                    <div className={styles['image-container']} onMouseEnter={this.addMask} onMouseLeave={this.removeMask} onClick={this.showZoomedImage}>
                        {this.getOrgChartImage()}
                        {/* {showMask ? <div className={styles['zoom-cursor']}> </div> : null} */}
                    </div>
                </div >

                {
                    showZoomedImage ?
                        <Dialog buttons={[]} containerClassName={styles['full-screen-image-box']}>
                            <div className={styles['full-screen-image']}>
                                {this.getOrgChartImage()}
                            </div>
                        </Dialog>

                        :
                        null
                }
            </React.Fragment>
        )
    }
}

export default Character;


// WEBPACK FOOTER //
// /src/components/intro/pages/about/character/Character.js